@if (datasetACS.datasetConfig) {
  <h1 mat-dialog-title>Dettagli {{datasetACS.datasetConfig.singleTitle | translate | titlecase}}</h1>
}
<mat-dialog-content>
  @if (loading || datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (!datasetACS.loading.value && datasetACS.datasetData.record) {
    <div class='mb-24'>
      <dataset-detail
        [showActions]='false'
        [showTitle]='false'
        [datasetCode]='datasetACS.datasetCode'
        [inputRecord]='datasetACS.datasetData.record'
      ></dataset-detail>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align='end'>
  <button mat-button color='' (click)="onCloseClick()">{{'Chiudi' | translate}}</button>
  @if (!loading && datasetACS.canEdit(datasetACS.datasetData.record) && datasetACS.actionEnabled("edit")) {
    <button class='ml-4' mat-flat-button color='accent' (click)="onEditClick()">{{'Modifica' | translate}}</button>
  }
</mat-dialog-actions>
